import { projectRipOntoWall } from '@geometry'
import { uniqBy } from 'lodash-es'
import { v4 as uuid } from 'uuid'

const buildRipCopyRequest = (rip: Rip, targetWall: ShapeObject): WallRipRequest | null => {
  const relativePosition = projectRipOntoWall(targetWall, rip.start)
  if (relativePosition === null) {
    return null
  }

  return {
    guid: uuid(),
    wall_guid: targetWall.guid,
    relative_position: relativePosition.toString(),
    rip_type: rip.rip_type,
    positionPlanSettings: rip.positionPlanSettings,
    certificateSettings: rip.certificateSettings,
  }
}

export const projectRipsOntoTargetWalls = (
  rips: Rip[],
  targetWalls: ShapeObject[],
): WallRipRequest[] => {
  const ripsToCreate: WallRipRequest[] = []

  for (const targetWall of targetWalls) {
    for (const rip of rips) {
      const request = buildRipCopyRequest(rip, targetWall)
      if (request) {
        ripsToCreate.push(request)
      }
    }
  }

  return uniqBy(ripsToCreate, r => `${r.wall_guid}-${r.relative_position}`)
}
